export default "__VITE_ASSET__Cma7LZpt__"